import React from 'react';
import { Button, Tooltip } from 'antd';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { getSourceString } from '../../../helpers/StringHelper';
import { EyeOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

export const filtersConfig = {
  locationName: '',
  datastakeId: '',
  // author: '',
  // territory: '',
  // province: '',
};

export const selectFiltersConfig = {
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => `${t('Filter by')} ${t('country')}`,
    style: { flex: 1 },
    labelStyle: { fley: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  administrativeLevel1: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel1 } = options;

      if (administrativeLevel1) {
        if (options.country) {
          const _item = administrativeLevel1[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => `${t('Filter by')} ${t('province')}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_1',
    }),
    disabled: (data) => !!!data.country,
    show: (data) => !!!data.country,
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { fley: 1 },
  },
  administrativeLevel2: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel2 } = options;

      if (administrativeLevel2) {
        if (options.country) {
          const _item = administrativeLevel2[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => `${t('Filter by')} ${t('Territory').toLowerCase()}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_2',
      administrativeLevel1: data.administrativeLevel1,
    }),
    show: (data) => !(data.country && data.administrativeLevel1),
    disabled: (data) => !(data.country && data.administrativeLevel1),
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { fley: 1 },
  },
  /*
  administrativelevel2: {
    type: 'ajaxSelect',
    label: 'Province',
    placeholder: 'Filter by province',
    filters: (data) => ({
      country: data.country,
      administrativelevel1: data.administrativelevel1,
    }),
    style: { width: 200 },
    getlabel: (option) => option.label,
    getvalue: (option) => option.value,
  },
  */
  category: {
    type: 'select',
    label: 'Type of Location',
    placeholder: (t) => `${t('Filter by')} ${t('Type of Location').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { fley: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  materialHandled: {
    type: 'select',
    label: 'Product',
    placeholder: (t) => `${t('Filter by')} ${t('Product').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { fley: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
};

export const checkboxConfig = {
  locationName: 'Name',
  datastakeId: 'ID',
  // author: 'Author',
  // territory: 'Territory',
  // province: 'Province',
};

const ViewStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .ghosted {
    border: 0px;

    span {
      text-decoration: underline;
    }
  }
`;
export const linkingColumns = (t, module = 'pme', view = 'locations') => [
  {
    title: t('Type of Subject'),
    dataIndex: 'type',
    key: 'type',
    show: true,
    search: true,
    render: type => t(type),
    searchType: 'dropdown',
  },
  {
    title: t('System ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    show: true,
    sorter: (a, b) => ('' + a.id).localeCompare(b.id),
    render: (id, item) => {
      let link = '';
      switch (item.type) {
        case 'stakeholder':
          link = `/app/${module}/stakeholders/${id}`;
          break;
        case 'event':
          link = `/app/${module}/events/${id}`;
          break;
        case 'location':
          link = `/app/${module}/locations/${id}`;
          break;
        case 'lir':
          link = `/app/${module}/lir/${id}`;
          break;
        default:
          link = '#';
          break;
      }
      return <NavLink className="projectLink" to={link}>
        {id}
      </NavLink>
    },
    search: true,
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
    show: true,
    render: (name) => name,
    search: true,
  },
  {
    title: t('Connected as'),
    dataIndex: 'usedAs',
    key: 'usedAs',
    show: true,
    render: (used) => {
      const language = localStorage.getItem('datastakeLng') || 'en';
      return used[language];
    },
    search: true,
  },
];

const columns = (t, module = 'pme', view = 'locations', filterBy = 'show', sourceId = 'overview', activeFilters = {}) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      ellipsis: true,
      overview: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      render: (id, item) => {
        let editView = view === 'locations' ? 'location' : view;
        const redirectView = (editView === 'scl' || item?.category === 'mineSite') ? 'analysis' : 'view';
        if (item.category === 'mineSite') {
          editView = 'scl';
        }
        let redirectUrl;
        switch (redirectView) {
          case 'view':
            redirectUrl = item.authorId
              ? `/app/${module}/${redirectView}/${editView}/${id}?sourceId=${item.authorId}`
              : `/app/${module}/${redirectView}/${editView}/${id}`;
            break;
          case 'analysis':
            redirectUrl = item.children
              ? `/app/${module}/${redirectView}/${editView}/${id}`
              : `/app/${module}/${redirectView}/${editView}/${id}/${item.authorId}`;
            // item.isChild  ? `/app/${module}/${mode}/${viewView}/${item.id}?defaultSources=${item.authorId}`
            break;
          default:
            redirectUrl = '';
        }
        return sourceId === 'overview' && item.children ? id : <NavLink
          className="projectLink"
          {...(filterBy === 'publication' ? {
            target: "_blank"
          } : {})}
          to={redirectUrl}
        >
          {id}
        </NavLink>
      },
      search: true,
      publication: true,
      width: 160,
      project: true,
    },
    {
      title: t('Name'),
      dataIndex: 'locationName',
      key: 'locationName',
      show: true,
      project: true,
      overview: true,
      primarySearch: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'locationName' ? activeFilters.sortDir : undefined,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Type'),
      dataIndex: 'locationType',
      key: 'category',
      sorter: view === 'locations' ? () => 0 + 0 : undefined,
      defaultSortOrder: activeFilters.sortBy === 'category' ? activeFilters.sortDir : undefined,
      show: true,
      project: true,
      overview: true,
      publication: true,
      searchType: 'dropdown',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      removeFromView: ['village', 'scl'],
    },
    {
      title: t('Sources'),
      dataIndex: 'sourcesLen',
      key: 'sourcesLen',
      overview: true,
      show: filterBy === 'overview',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: true,
      project: true,
      publication: true,
      searchType: 'dropdown',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Province'),
      dataIndex: 'province',
      key: 'province',
      show: true,
      project: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'territory',
      key: 'territory',
      show: true,
      project: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Products'),
      dataIndex: 'mineralTitleScope',
      key: 'mineralTitleScope',
      show: view === 'scl' ? true : false,
      publication: false,
      project: true,
      render: (v) => {
        const title = (v || '').length ? v : '-';
        return <Tooltip title={title}>{title}</Tooltip>;
      },
      ellipsis: true,
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      show: false,
      project: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Author'),
      dataIndex: 'author',
      key: 'author',
      show: filterBy === 'project',
      search: true,
      project: true,
      publication: false,
      render: (author, item) => {
        const title = getSourceString(author, item);
        return <Tooltip title={title}>{title}</Tooltip>;
      },
      ellipsis: true,
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      show: filterBy === 'project',
      project: true,
      publication: false,
      render: (_, item) => {
        const mode = (view === 'scl' || item.category === 'mineSite') ? 'analysis' : 'view';
        let viewView = view === 'locations' ? 'location' : view;
        if (item.category === 'mineSite') {
          viewView = 'scl';
        }

        const pathname = (item.children)
          ? `/app/${module}/${mode}/${viewView}/${item.id}`
          : `/app/${module}/${mode}/${viewView}/${item.id}/${item.authorId}`;
        // item.isChild  ? `/app/${module}/${mode}/${viewView}/${item.id}?defaultSources=${item.authorId}`

        if (item.children && view !== 'scl') {
          return null;
        }

        return (
          <ViewStyle className="view-btn-scl-table">
            <Link to={pathname}>
              <Button
                className={formatClassname([
                  item.children ? 'primary' : 'ghosted',
                  'no-ln-height',
                ])}
                type={item.children ? 'primary' : 'ghost'}
                icon={<EyeOutlined />}
              >
                {t('View')}
              </Button>
            </Link>
          </ViewStyle>
        )
      }
    }
  ];
  const filteredCols = cols.filter(c => c.show && !(Array.isArray(c.removeFromView) && c.removeFromView.includes(view)));

  if (filterBy !== 'show') {
    return cols.filter(col => col[filterBy]);
  }

  return filteredCols;
}
export default columns;
